import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _findIndexInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find-index";
import _spliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/splice";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { GenericModal } from "@Shared/components/modals";
import { showToast } from "@Shared/@Utils/constants";
import { mapActions, mapGetters } from "vuex";
import { UPDATE_SYNCED_CALENDARS, LOAD_SYNCED_CALENDARS } from "@Broker/@Modules/settings/store/settings-actions";
import { GET_CALENDARS } from "@Broker/@Modules/settings/store/settings-getters";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import CheckboxSection from "@Shared/components/sections/checkbox-section";
import Amplitude from "@Shared/utils/amplitude";
import { cloneDeep } from "lodash";
import ManageEmailCalendarsModalLoader from "./manage-email-calendars-modal-loader.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ManageEmailCalendarsModal",
  components: {
    GenericModal,
    SimpleButton,
    CheckboxSection,
    ManageEmailCalendarsModalLoader
  },
  props: {
    selectedAccountId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      loadingSucceeded: null,
      syncedCalendars: [],
      changedSyncedCalendarIds: [],
      loadingCalendars: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters("SettingsStore", [GET_CALENDARS])), {}, {
    noCalendars() {
      return this.syncedCalendars.length < 1;
    }
  }),
  methods: _objectSpread(_objectSpread({}, mapActions("SettingsStore", [UPDATE_SYNCED_CALENDARS, LOAD_SYNCED_CALENDARS])), {}, {
    openModal() {
      this.init();
      this.$showModal();
    },
    closeModal() {
      this.$hideModal();
    },
    async init() {
      this.loadingCalendars = true;
      this.changedSyncedCalendarIds = [];
      await this.LOAD_SYNCED_CALENDARS();
      this.syncedCalendars = cloneDeep(this.GET_CALENDARS(this.selectedAccountId));
      this.loadingCalendars = false;
    },
    async handleSave() {
      this.loading = true;
      try {
        await this.UPDATE_SYNCED_CALENDARS(this.changedSyncedCalendarIds);
        this.changedSyncedCalendarIds = [];
        showToast("success", "syncCalendarsSaved");
        this.closeModal();
        this.loadingSucceeded = true;
      } catch (e) {
        Amplitude.logHandledError(e);
        this.loadingSucceeded = false;
        this.init();
      } finally {
        this.loading = false;
      }
    },
    changeSyncedCalendar(calendarId) {
      var _context;
      const calendarIndex = _findIndexInstanceProperty(_context = this.changedSyncedCalendarIds).call(_context, id => id == calendarId);
      if (calendarIndex >= 0) {
        var _context2;
        _spliceInstanceProperty(_context2 = this.changedSyncedCalendarIds).call(_context2, calendarIndex, 1);
      } else {
        this.changedSyncedCalendarIds.push(calendarId);
      }
    }
  })
});